var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOk = function SvgOk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 97 114"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ok_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9673FF",
    d: "M29.593 40.849A59990 59990 0 0 0 44.91 7.248c3.547-6.01 10.852-8.704 17.363-6.47 6.67 2.285 10.81 9.165 9.708 16.228 6.879-3.515 15.11-1.883 19.684 3.615 3.79 4.561 4.55 11.147 1.953 16.838 1.01 1.532 2.972 4.93 3.323 9.7.384 5.222-1.37 9.155-2.212 10.787.383 1.573.81 4.352-.15 7.473-2.296 7.432-10.31 9.767-11.028 9.96a109 109 0 0 0-7.73 4.477 108 108 0 0 0-4.566 3.07 37.9 37.9 0 0 1-6.486 8.922c-4.416 4.52-9.057 6.988-12.096 8.31l-9.516 12.353a3.82 3.82 0 0 1-4.475 1.205A98.8 98.8 0 0 1 .927 86.275a3.85 3.85 0 0 1-.117-4.83c3.414-4.435 6.828-8.879 10.234-13.314a38.14 38.14 0 0 1 6.169-15.775 37.86 37.86 0 0 1 12.396-11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m90.278 46.539-.492 3.615a.9.9 0 0 0 .075.51l1.536 3.306c.309.661-.242 1.398-.96 1.306l-3.606-.494a.9.9 0 0 0-.51.075l-3.297 1.54c-.66.31-1.394-.243-1.302-.962l.493-3.616a.9.9 0 0 0-.076-.51l-1.536-3.306c-.308-.66.242-1.397.96-1.305l3.606.493c.176.026.351 0 .51-.075l3.297-1.54c.66-.31 1.394.243 1.302.963M88.564 61.394l-.242 1.808a.5.5 0 0 0 .042.259l.768 1.657a.46.46 0 0 1-.476.653l-1.803-.243a.47.47 0 0 0-.259.042l-1.653.77a.46.46 0 0 1-.651-.477l.242-1.808a.47.47 0 0 0-.042-.26l-.768-1.656a.46.46 0 0 1 .476-.653l1.803.243c.084.008.176 0 .26-.042l1.652-.77a.46.46 0 0 1 .651.477"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9673FF",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.286,
    d: "m25.477 52.43-3.546 5.762c-6.218 10.106-3.088 23.352 6.993 29.586l4.241 2.623c10.08 6.234 23.293 3.096 29.511-7.01l3.546-5.762c6.218-10.106 3.087-23.352-6.993-29.586l-4.241-2.623c-10.08-6.234-23.293-3.096-29.511 7.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9673FF",
    d: "M50.9 44.623 63.44 15.508c1.402-3.247-.259-7.122-3.681-8.603a6.98 6.98 0 0 0-5.143-.168c-2.062.754-3.088 2.419-3.623 3.381-2.028 3.674-7.997 16.797-15.601 34.706"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.286,
    d: "M50.9 44.623 63.44 15.508c1.402-3.247-.259-7.122-3.681-8.603a6.98 6.98 0 0 0-5.143-.168c-2.062.754-3.088 2.419-3.623 3.381-2.028 3.674-7.997 16.797-15.601 34.706"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9673FF",
    d: "m60.423 54.765 24.742-21.29c2.763-2.377 3.03-6.636.61-9.473-2.43-2.837-6.67-3.214-9.433-.837-8.482 7.155-16.954 14.31-25.436 21.457"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.286,
    d: "m60.423 54.765 24.742-21.29c2.763-2.377 3.03-6.636.61-9.473-2.43-2.837-6.67-3.214-9.433-.837-8.482 7.155-16.954 14.31-25.436 21.457"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9673FF",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.286,
    d: "M68.876 61.367c3.56-1.16 5.508-4.994 4.351-8.563-1.156-3.57-4.98-5.523-8.54-4.363l-8.758 2.852c-3.56 1.16-5.508 4.994-4.352 8.563 1.157 3.57 4.981 5.523 8.542 4.363z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m58.235 52.984-1.429.465a3.72 3.72 0 0 0-2.38 4.683l.465 1.432a3.705 3.705 0 0 0 4.67 2.386l1.43-.466a3.72 3.72 0 0 0 2.379-4.682l-.464-1.432a3.705 3.705 0 0 0-4.67-2.386"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9673FF",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.286,
    d: "M72.727 74.453c3.56-1.16 5.509-4.993 4.352-8.562-1.157-3.57-4.98-5.523-8.541-4.363L59.78 64.38c-3.56 1.16-5.509 4.994-4.352 8.563s4.98 5.523 8.541 4.363z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m61.868 66.144-1.429.466a3.72 3.72 0 0 0-2.38 4.682l.465 1.432a3.704 3.704 0 0 0 4.67 2.386l1.43-.466a3.72 3.72 0 0 0 2.379-4.682l-.465-1.432a3.704 3.704 0 0 0-4.67-2.386"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.286,
    d: "M38.665 64.223c.434 1.263.926 3.247.81 5.674-.192 3.95-1.904 6.787-2.772 8.025"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9673FF",
    d: "m35.89 63.343 13.114 2.971c3.632.82 7.28-1.48 8.106-5.13.818-3.64-1.477-7.297-5.117-8.126a43.8 43.8 0 0 0-13.114-2.97 44 44 0 0 0-7.613.15"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.286,
    d: "m35.89 63.343 13.114 2.971c3.632.82 7.28-1.48 8.106-5.13.818-3.64-1.477-7.297-5.117-8.126a43.8 43.8 0 0 0-13.114-2.97 44 44 0 0 0-7.613.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m52.427 55.235-1.44-.432a3.705 3.705 0 0 0-4.613 2.493l-.432 1.443a3.717 3.717 0 0 0 2.487 4.626l1.44.432a3.705 3.705 0 0 0 4.614-2.493l.43-1.443a3.717 3.717 0 0 0-2.486-4.626"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.286,
    d: "M40.1 106.669 8.32 83.152a.71.71 0 0 1-.15-.996l6.645-9.021c.117-.16 5.902.334 18.607 9.557 11.453 8.695 14.65 13.742 14.317 14.804l-6.645 9.022a.707.707 0 0 1-.993.151"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M40.476 106.948c.966-1.313-5.678-7.873-14.84-14.652-9.162-6.78-17.373-11.211-18.34-9.899s5.678 7.873 14.84 14.653c9.163 6.779 17.373 11.211 18.34 9.898"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ok_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h97v114H0z"
  })))));
};
export default SvgOk;